import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  connect () {
    this.typingTimer = null
    this.doneTypingInterval = 1000
  }

  keyup () {
    clearTimeout(this.typingTimer)
    this.typingTimer = setTimeout(() => {
      this.dispatch('searchText', { detail: { searchText: this.inputTarget.value } })
    }, this.doneTypingInterval)
  }

  keydown () {
    clearTimeout(this.typingTimer)
  }
}
